import React from "react";
import styles from "./SatelliteAnimation.module.css";

const NUM_STARS = 100;

const SatelliteAnimation = () => {
  const stars = Array.from({ length: NUM_STARS }, () => ({
    top: Math.random() * 100,
    left: Math.random() * 100,
    size: Math.random() * 2 + 1,
  }));

  return (
    <>
      <div className={styles.starContainer}>
        {stars.map((star, index) => (
          <div
            key={index}
            className={styles.stars}
            style={{
              top: `${star.top}%`,
              left: `${star.left}%`,
              width: `${star.size}px`,
              height: `${star.size}px`,
              animationDuration: `${Math.random() * 5 + 3}s`, // random twinkle speed
            }}
            aria-hidden="true"
          />
        ))}
      </div>

      {/* <div className={styles.container} aria-hidden="true" role="presentation">
        {theme === 'dark' ? (<MoonCanvas />) : (<SunCanvas />)}
      </div> */}
    </>
  );
};

export default SatelliteAnimation;
